const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getUsers(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }
  
  return response.json();
}

export async function getUser(orgId, userId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users/${userId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch user');
  }
  
  const data = await response.json();
  return data.user;
}

export async function createUser(orgId, userData) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(userData)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to create user');
  }
  
  const data = await response.json();
  return data.user;
}

export async function updateUser(orgId, userId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/users/${userId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to update user');
  }
  
  const data = await response.json();
  return data.user;
}
